import type { ImageView } from '@repo/api-contracts';
import { type ReactElement, useEffect, useState } from 'react';
import { PortfolioPhoto } from './portfolio-photo';
import { PortfolioThumbnail } from './portfolio-thumbnail';

interface PortfolioGalleryProps {
  readonly portfolioId: string;
  readonly title: string;
  readonly images: ImageView[];
  readonly onRetry: () => void;
}

export const PortfolioGallery = ({
  portfolioId,
  title,
  images,
  onRetry,
}: PortfolioGalleryProps): ReactElement => {
  const [selection, setSelection] = useState({ portfolioId, imageId: images[0]?.id });
  const selected =
    (selection.portfolioId === portfolioId &&
      images.find((image) => image.id === selection.imageId)) ||
    images[0];
  useEffect(() => {
    if (selection.portfolioId !== portfolioId || selection.imageId !== selected?.id) {
      setSelection({ portfolioId, imageId: selected?.id });
    }
  }, [portfolioId, selected?.id, selection]);
  return (
    <section aria-label="사례 사진" className="min-w-0 space-y-4">
      {selected !== undefined && (
        <PortfolioPhoto
          key={`${portfolioId}:${selected.id}:${selected.largeUrl}`}
          src={selected.largeUrl}
          title={title}
          onRetry={onRetry}
        />
      )}
      {/* 사진이 한 장이면 고를 것이 없어 썸네일 줄을 두지 않는다. */}
      {images.length > 1 && (
        <fieldset
          className="flex min-w-0 gap-2 overflow-x-auto p-1 sm:gap-3"
          aria-label="사진 선택"
        >
          {images.map((image, index) => (
            <PortfolioThumbnail
              key={image.id}
              image={image}
              title={title}
              number={index + 1}
              selected={selected?.id === image.id}
              onSelect={() => setSelection({ portfolioId, imageId: image.id })}
            />
          ))}
        </fieldset>
      )}
    </section>
  );
};
